/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { calculateFee } from '../utilities/ticket_fees';
import { NON_TAXABLE_PRODUCTS, DEFAULT_TAXABLE_PRODUCT } from './constants/tax_products';
import { DateInputRow } from '../../../../../javascript/shared/components/form';
import { getPlatformTimeZoneName, getDatePartsInPlatformTZ, buildISOStringInPlatformTZ } from '../../../../../javascript/shared/utils/platform-timezone';
import * as Utilities from '../utilities';
import { FormHeader } from '../../react/form_header.jsx';
import { FormThemeContext } from '../../react/form_theme_context.js.jsx';
import { Link } from '../../../admin/react/common/link.js.jsx';
import { FormInputGroup } from '../../react/form_input_group.jsx';

import * as Actions from '../store/actions';
import { FormRow } from '../../react/form_row.jsx';
import { CurrencyInput } from '../../react/currency_input.jsx';

import React from 'react';
import PropTypes from 'prop-types';
import { Info } from '../../../admin/react/common/info.js.jsx';

const toDate = function(val) {
      if (val instanceof Date) { return val; }
      if ((typeof val === 'string') && (val.length > 0)) {
        const str = val.indexOf('T') === -1 ? val.replace(' ', 'T') : val;
        const d = new Date(str);
        if (!isNaN(d.getTime())) { return d; }  return null; 
      } 
        return null;
      
    };

    const extractTime = function(date) {
      const d = toDate(date);
      if (!d) { return null; }
      const parts = getDatePartsInPlatformTZ(d);
      if (parts) {
        if ((parts.hour !== 0) || (parts.minute !== 0)) {
          const result = new Date(d);
          result.setHours(parts.hour, parts.minute, 0, 0);
          return result;
        } 
          return null;
        
      } 
        if ((d.getUTCHours() !== 0) || (d.getUTCMinutes() !== 0)) {
          return d;
        } 
          return null;
        
      
    };

    const buildDateTimeString = function(dateVal, timeVal) {
      let hours = 0;
      let minutes = 0;
      if (timeVal instanceof Date) {
        hours = timeVal.getHours();
        minutes = timeVal.getMinutes();
      }
      const parts = getDatePartsInPlatformTZ(dateVal);
      if (parts) {
        return buildISOStringInPlatformTZ(parts.year, parts.month - 1, parts.day, hours, minutes);
      } 
        return buildISOStringInPlatformTZ(dateVal.getFullYear(), dateVal.getMonth(), dateVal.getDate(), hours, minutes);
      
    };

    const dateOnlyString = function(val) {
      let day; let m;
      const d = toDate(val);
      if (!d) { return val; }
      const parts = getDatePartsInPlatformTZ(d);
      if (parts) {
        m = parts.month < 10 ? `0${  parts.month}` : `${  parts.month}`;
        day = parts.day < 10 ? `0${  parts.day}` : `${  parts.day}`;
        return `${parts.year}-${m}-${day}`;
      } 
        m = d.getMonth() + 1;
        day = d.getDate();
        return `${d.getFullYear()}-${m < 10 ? `0${  m}` : `${  m}`}-${day < 10 ? `0${  day}` : `${  day}`}`;
      
    };

export class TicketForm extends React.Component {
  static contextType = FormThemeContext;

  static propTypes = {
    // Ticket data
    ticket: Actions.TicketClassShape,
    // Callback when an input field changes
    onChange: PropTypes.func,
    // Callback for the "Update" button, which just closes the editor
    onClose: PropTypes.func
  };

        constructor(props) {
          super(props);
          this.onInputChange = this.onInputChange.bind(this);
          this.onPriceChange = this.onPriceChange.bind(this);
          this.inputChanged = this.inputChanged.bind(this);
          this.dateInputChanged = this.dateInputChanged.bind(this);
          this.timeInputChanged = this.timeInputChanged.bind(this);
          this.onHasOnsaleDatesChange = this.onHasOnsaleDatesChange.bind(this);
          this.onAdvancedOptionsToggle = this.onAdvancedOptionsToggle.bind(this);
          this.isValid = this.isValid.bind(this);
          this.isValidUrl = this.isValidUrl.bind(this);

          this.timeZoneName = getPlatformTimeZoneName();

          this.state = {
            hasOnsaleDates:      !!props.ticket.availability_start || !!props.ticket.availability_finish,
            advancedOptionsOpen: false,
            urlRegex:            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
            ticketUrlError:      null,
            availabilityStartTime:  extractTime(props.ticket.availability_start),
            availabilityFinishTime: extractTime(props.ticket.availability_finish)
          };
        }

        onInputChange(event, name, value) {
          const field_name = (name != null) ? name : event.target.name;
          const field_value = (value != null) ?
            value
          : event.target.type === 'checkbox' ?
            // Use the checked state of checkboxes, instead of the value
            event.target.checked
          : (event.target.name === 'customer_pays_fees') || (event.target.name === 'donation') ?
            // Customer pays fees is a boolean, but presented as a dropdown, so convert it
            event.target.value === '1'
          :
            event.target.value;

          // If taxable changes from false to true, set the default tax product to a taxable one
          if ((field_name === 'taxable') && (field_value === true) && (this.props.ticket.taxable === false)) {
            if (NON_TAXABLE_PRODUCTS.includes(this.props.ticket.tax_product)) {
              if (typeof this.props.onChange === 'function') {
                this.props.onChange('tax_product', DEFAULT_TAXABLE_PRODUCT);
              }
            }
          }

          return (typeof this.props.onChange === 'function' ? this.props.onChange(field_name, field_value, event) : undefined);
        }

        onPriceChange(event, cents) {
          return this.onInputChange(event, event.target.name, cents);
        }

        // Returns a callback function to call onInputChange with the specified name
        inputChanged(name) {
          return event => this.onInputChange(event, name);
        }

        dateInputChanged(event, value, input_value) {
          let new_value;
          const fieldName = event.target.name;
          if (value === 'blank') {
            new_value = '';
          } else if (value !== 'error') {
            const timeState = fieldName === 'availability_start' ? this.state.availabilityStartTime : this.state.availabilityFinishTime;
            new_value = buildDateTimeString(value, timeState);
          }

          return this.onInputChange(event, fieldName, new_value);
        }

        timeInputChanged(event, value, input_value) {
          let currentDate; let stateUpdate;
          const inputName = event.target.name;
          const isStart = inputName === 'availability_start_time';
          const dateFieldName = isStart ? 'availability_start' : 'availability_finish';
          const timeStateKey = isStart ? 'availabilityStartTime' : 'availabilityFinishTime';

          if (value === 'blank') {
            stateUpdate = {};
            stateUpdate[timeStateKey] = null;
            this.setState(stateUpdate);
            currentDate = toDate(this.props.ticket[dateFieldName]);
            if (currentDate) {
              return this.onInputChange(event, dateFieldName, buildDateTimeString(currentDate, null));
            }
          } else if (value !== 'error') {
            stateUpdate = {};
            stateUpdate[timeStateKey] = value;
            this.setState(stateUpdate);
            currentDate = toDate(this.props.ticket[dateFieldName]);
            if (currentDate) {
              return this.onInputChange(event, dateFieldName, buildDateTimeString(currentDate, value));
            }
          }
        }

        // Toggle visibility of onsale dates
        onHasOnsaleDatesChange(event) {
          this.setState({hasOnsaleDates: event.target.checked});

          // Clear the set values when unchecking
          if (!event.target.checked) {
            if (typeof this.props.onChange === 'function') {
              this.props.onChange('availability_start', null);
            }
            if (typeof this.props.onChange === 'function') {
              this.props.onChange('availability_finish', null);
            }
            return this.setState({
              availabilityStartTime: null,
              availabilityFinishTime: null
            });
          }
        }

        // Toggle visibility of advanced options
        onAdvancedOptionsToggle(event) {
          event.preventDefault();
          return this.setState({advancedOptionsOpen: !this.state.advancedOptionsOpen});
        }

        // Validate the ticket type props
        isValid() {
          if (this.props.ticket.name.isBlank()) { return false; }

          return true;
        }

        isValidUrl(str) {
          return str && (str.match(this.state.urlRegex) !== null);
        }

        render() {
          const id_prefix = `ticket-form-${this.props.ticket.id}`;

          const fee_preview = (() => {
            if (this.props.ticket.price > 0) {
            // Calculate fee
            const fee_amount = calculateFee(this.props.ticket.price, this.props.ticket.customer_pays_fees, this.props.settings.fees);

            if (this.props.ticket.customer_pays_fees) {
              return <p className="preview">Fees: {Utilities.formatCurrency(fee_amount)}</p>;
            } 
              return <p className="preview">Fees: {Utilities.formatCurrency(fee_amount)}</p>;
            
          } 
            return null;
          
          })();

          const tax_product_needs_location = !this.props.settings.event_has_address && this.props.settings.tax_products_requiring_location.includes(this.props.ticket.tax_product);

          return <tr>
            <td className="edit-form" colSpan="5">
              <FormInputGroup>
                <FormRow title="Active"
                         labelFor={`${id_prefix  }-active`}
                         tooltip="Allow this ticket to be used"
                         {...this.context.checkboxRow}>
                  <input name="active"
                         id={`${id_prefix  }-active`}
                         type="checkbox"
                         className={this.context.checkboxRow.className}
                         checked={this.props.ticket.active}
                         onChange={this.onInputChange} />
                </FormRow>

                <FormRow title="Ticket Name"
                         labelFor={`${id_prefix  }-name`}
                         {...this.context.textInputRow}
                         required>
                  <input name="name"
                         type="text"
                         className={this.context.textInputRow.inputClassName}
                         value={this.props.ticket.name}
                         onChange={this.onInputChange}
                         autoFocus />
                </FormRow>

                <FormRow title="Description"
                         tooltip="Limited to 160 characters"
                         labelFor={`${id_prefix  }-description`}
                         {...this.context.textInputRow}>
                  <input type="text"
                         id={`${id_prefix  }-description`}
                         className={this.context.textInputRow.inputClassName}
                         maxLength="160"
                         name="description"
                         value={this.props.ticket.description}
                         onChange={this.onInputChange} />
                </FormRow>

                <FormRow title='Ticket Type'
                         labelFor={`${id_prefix  }-ticket_type`}
                         {...this.context.selectInputRow}
                         tooltip="Selecting virtual will replace traditional tickets with a link to the event URL (like a Zoom link)">
                  <select name='ticket_type'
                          id={`${id_prefix  }-ticket_type`}
                          value={this.props.ticket.ticket_type}
                          className={this.context.selectInputRow.inputClassName}
                          onChange={this.onInputChange}>
                    <option value='in_person'>In-Person</option>
                    <option value='virtual'>Virtual</option>
                    <option value='wait_list'>Waiting List</option>
                  </select>
                </FormRow>

                {this.props.ticket.ticket_type === 'virtual' &&
                  <FormRow title='Event URL'
                           labelFor={`${id_prefix  }-virtual_event_url`}
                           {...this.context.textInputRow}>
                    <input type='text'
                           id={`${id_prefix  }-virtual_event_url`}
                           className={this.context.textInputRow.inputClassName}
                           name='virtual_event_url'
                           value={this.props.ticket.virtual_event_url}
                           onChange={this.onInputChange}/>
                    <p className="error">{this.state.ticketUrlError}</p>
                </FormRow>}

                <FormRow title='Ticket Type Message'
                         labelFor={`${id_prefix  }-virtual_event_message`}
                         {...this.context.textInputRow}>
                  <textarea name='virtual_event_message'
                            id={`${id_prefix  }-virtual_event_message`}
                            className={this.context.textInputRow.inputClassName}
                            value={this.props.ticket.virtual_event_message}
                            onChange={this.onInputChange}/>
                </FormRow>

                {!this.props.settings.has_payout_account && <Info>
                  <div className='admin-common-info'>
                    <i className="fa fa-info-circle" aria-hidden="true"></i>
                    <p>
                      You must add a payout account in order to set pricing options.
                      In order to add a Payout Account, go to <Link text="Settings > Register" href="/admin/registration" target="_blank" />
                    </p>
                  </div>
                </Info>}

                <FormRow title="Price Type"
                          labelFor={`${id_prefix  }-donation`}
                          {...this.context.selectInputRow}
                          className=""
                          tooltip="Use User-Specified for donation tickets">
                  <select name="donation"
                          id={`${id_prefix  }-donation`}
                          className={this.context.selectInputRow.inputClassName}
                          onChange={this.onInputChange}
                          disabled={!this.props.settings.has_payout_account}
                          value={this.props.ticket.donation ? "1" : "0"}>
                    <option value="0">Fixed</option>
                    <option value="1">User-Specified (Donation)</option>
                  </select>
                </FormRow>

                {this.props.settings.tax_enabled && (
                  <React.Fragment>
                    <FormRow title="Taxable"
                            labelFor={`${id_prefix  }-taxable`}
                            {...this.context.checkboxRow}>
                      <input name="taxable"
                            id={`${id_prefix  }-taxable`}
                            type="checkbox"
                            className={this.context.checkboxRow.className}
                            checked={this.props.ticket.taxable}
                            onChange={this.onInputChange}
                            aria-describedby={`${id_prefix  }-taxable-info`} />
                    </FormRow>

                    {(!this.props.settings.payout_account_supports_tax && this.props.ticket.taxable) && <Info>
                      <div className='admin-common-info' id={`${id_prefix  }-taxable-info`}>
                        <i className="fa fa-info-circle" aria-hidden="true"></i>
                        <p>
                          The selected payout account does not support tax collection.
                        </p>
                      </div>
                    </Info>
                    }

                    {this.props.ticket.taxable && <FormRow title="Tax Product"
                              labelFor={`${id_prefix  }-tax_product`}
                              {...this.context.selectInputRow}
                              className="">
                      <select name="tax_product"
                              id={`${id_prefix  }-tax_product`}
                              className={this.context.selectInputRow.inputClassName}
                              onChange={this.onInputChange}
                              disabled={!this.props.settings.has_payout_account}
                              value={this.props.ticket.tax_product}
                              aria-describedby={`${id_prefix  }-tax_product_needs_location`}>
                        {this.props.settings.tax_products.map((tax_product) =>
                          <option key={tax_product.value} value={tax_product.value}>{tax_product.name}</option>
                        )}
                      </select>
                    </FormRow>}

                    {tax_product_needs_location && <Info>
                      <div className='admin-common-info' id={`${id_prefix  }-tax_product_needs_location`}>
                        <i className="fa fa-info-circle"></i>
                        <p>This tax product requires the event's location. Please set the event's location on the Basic Information tab.</p>
                      </div>
                    </Info>}
                  </React.Fragment>
                 )}

                <FormRow title="Fees"
                         labelFor={`${id_prefix  }-customer_pays_fees`}
                         {...this.context.selectInputRow}
                         className="">
                    <select name="customer_pays_fees"
                            id={`${id_prefix  }-customer_pays_fees`}
                            className={this.context.selectInputRow.inputClassName}
                            onChange={this.onInputChange}
                            disabled={!this.props.settings.has_payout_account || !this.props.settings.customer_pays_fees_supported}
                            value={!this.props.settings.customer_pays_fees_supported ? "0" : this.props.ticket.customer_pays_fees ? "1" : "0"}>
                      <option value="1">Pass fees on to customer</option>
                      <option value="0">Organizer pays fees</option>
                    </select>
                    {(!this.props.settings.has_payout_account || !this.props.settings.customer_pays_fees_supported) &&
                      <p className="warning-message">The selected payout account does not support passing fees on to the customer.</p>
                    }
                </FormRow>

                {!this.props.ticket.donation && <FormRow title="Price">
                  <div className="rightside">
                    <CurrencyInput name="price"
                                   value={this.props.ticket.price}
                                   disabled={!this.props.settings.has_payout_account}
                                   currency={this.props.settings.currency}
                                   onChange={this.onPriceChange}/>
                    {fee_preview}
                  </div>
                </FormRow>}

                {this.props.ticket.donation && this.props.settings.has_payout_account && <FormRow title="Min Price">
                  <div className="rightside">
                    <CurrencyInput name="min_price" value={this.props.ticket.min_price} currency={this.props.settings.currency} onChange={this.onPriceChange} />
                  </div>
                </FormRow>}

                {this.props.ticket.donation && this.props.settings.has_payout_account && <FormRow title="Max Price">
                  <div className="rightside">
                    <CurrencyInput name="max_price" value={this.props.ticket.max_price} currency={this.props.settings.currency} onChange={this.onPriceChange} />
                  </div>
                </FormRow>}
              </FormInputGroup>

              {!this.state.advancedOptionsOpen && <FormRow title="">
                <a href="#" onClick={this.onAdvancedOptionsToggle}>Additional ticket options</a>
              </FormRow>}

              {this.state.advancedOptionsOpen && <div>
                <FormHeader title="Ticket Availability Dates" className="sub-heading"/>

                <FormInputGroup>
                  <DateInputRow label="On Sale From"
                                name="availability_start"
                                initialValue={dateOnlyString(this.props.ticket.availability_start)}
                                placeholder="'Tomorrow' or 'Next Friday' or '4/10'"
                                tooltip="Ticket will not be available for purchase until this date"
                                {...this.context.textInputRow}
                                onChange={this.dateInputChanged} />

                  <DateInputRow label="On Sale Start Time"
                                name="availability_start_time"
                                type="time"
                                initialValue={this.state.availabilityStartTime}
                                placeholder="'6pm'"
                                tooltip="Time of day ticket becomes available for purchase"
                                timeZoneName={this.timeZoneName || ""}
                                {...this.context.textInputRow}
                                onChange={this.timeInputChanged} />

                  <DateInputRow label="On Sale To"
                                name="availability_finish"
                                initialValue={dateOnlyString(this.props.ticket.availability_finish)}
                                placeholder="'Tomorrow' or 'Next Friday' or '4/10'"
                                tooltip="Ticket will become unavailable for purchase on this date"
                                {...this.context.textInputRow}
                                onChange={this.dateInputChanged} />

                  <DateInputRow label="On Sale End Time"
                                name="availability_finish_time"
                                type="time"
                                initialValue={this.state.availabilityFinishTime}
                                placeholder="'6pm'"
                                tooltip="Time of day ticket becomes unavailable for purchase"
                                timeZoneName={this.timeZoneName || ""}
                                {...this.context.textInputRow}
                                onChange={this.timeInputChanged} />
                </FormInputGroup>

                <FormHeader title="Settings" className="sub-heading"/>

                <FormInputGroup>
                  <FormRow title="Hidden"
                           labelFor={`${id_prefix  }-hidden`}
                           {...this.context.checkboxRow}
                           tooltip="Ticket will be hidden until an associated promo code is entered">
                    <input name="hidden"
                           id={`${id_prefix  }-hidden`}
                           className={this.context.checkboxRow.className}
                           type="checkbox"
                           checked={this.props.ticket.hidden}
                           onChange={this.onInputChange} />
                  </FormRow>

                  <FormRow title="Tickets Available"
                           tooltip="The number of times this ticket can be purchased"
                           labelFor={`${id_prefix  }-quantity_limit`}
                           {...this.context.textInputRow}>
                    <input name="quantity_limit"
                           id={`${id_prefix  }-quantity_limit`}
                           className={this.context.textInputRow.inputClassName}
                           type="text"
                           value={this.props.ticket.quantity_limit}
                           onChange={this.onInputChange} />
                  </FormRow>

                  <FormRow title="Min. Quantity Per Sale"
                           tooltip="The minimum number of tickets required per transaction (for four-pack orders, etc.)"
                           labelFor={`${id_prefix  }-purchase_maximum`}
                           {...this.context.textInputRow}>
                    <input name="purchase_minimum"
                           type="text"
                           className={this.context.textInputRow.inputClassName}
                           id={`${id_prefix  }-purchase_maximum`}
                           value={this.props.ticket.purchase_minimum}
                           onChange={this.onInputChange} />
                  </FormRow>

                  <FormRow title="Max. Quantity Per Sale"
                           tooltip="The maximum number of tickets allowed per transaction (to prevent cyberscalping)"
                           labelFor={`${id_prefix  }-purchase_limit`}
                           {...this.context.textInputRow}>
                    <input name="purchase_limit"
                           type="text"
                           id={`${id_prefix  }-purchase_limit`}
                           className={this.context.textInputRow.inputClassName}
                           value={this.props.ticket.purchase_limit}
                           onChange={this.onInputChange} />
                  </FormRow>

                </FormInputGroup>
              </div>}

              <div className="action-button pull-right">
                <button className="btn-color"
                        disabled={!this.isValid()}
                        onClick={this.props.onClose}>
                  Save {this.props.ticket.name}
                </button>
              </div>
            </td>
          </tr>;
        }
}
